export const LOCALES = ['en'];
export const WAREHOUSES = ['GA', 'NY', 'CA', 'TX', 'WA', 'VA'];

export const CUSTOMER_SERVICE_EMAIL = 'cservice@w8shipping.com';

// Global timezone used across the app
export const DEFAULT_TIMEZONE = process.env.NEXT_PUBLIC_DEFAULT_TIMEZONE || 'America/New_York';